// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lnwbx","right":"styles_right__3Oq0l"};